import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/react-datepicker.css';
import './index.css';
import './components/common/RTStatusPill.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);